(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gsa-bike-results"] && !Shopify.designMode) return;
  try {
    
  class GsaBikeContext extends HTMLElement {
    connectedCallback() {
      const params = new URLSearchParams(window.location.search);
      const model = params.get('model');
      const year = params.get('year');
      const variant = params.get('variant');

      if (model) {
        const variantLabel = variant === 'adventure' ? 'GS Adventure' : '';
        const textEl = this.querySelector('[data-gsa-bike-text]');
        if (textEl) {
          textEl.textContent = [model, variantLabel, year].filter(Boolean).join(' ');
        }
      }

      document.querySelectorAll('[data-gsa-bike-link]').forEach((link) => {
        if (!params.toString()) return;
        const url = new URL(link.href, window.location.origin);
        params.forEach((value, key) => url.searchParams.set(key, value));
        link.href = url.pathname + url.search;
      });
    }
  }
  customElements.define('gsa-bike-context', GsaBikeContext);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsa-brand-strip"] && !Shopify.designMode) return;
  try {
    
  class GsaBrandIndicator extends HTMLElement {
    connectedCallback() {
      const container = this.querySelector('.gsa-brand-strip');
      if (!container) return;

      const thickness = parseFloat(this.dataset.indicatorThickness) || 4;
      const lengthPct = parseFloat(this.dataset.indicatorLength) || 50;

      const indicator = document.createElement('div');
      indicator.className = 'gsa-brand-indicator';
      indicator.style.height = `${thickness}px`;
      indicator.innerHTML = '<span></span><span></span><span></span>';
      container.appendChild(indicator);

      const items = container.querySelectorAll('.gsa-brand-strip__item');
      items.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          const containerRect = container.getBoundingClientRect();
          const itemRect = item.getBoundingClientRect();
          const indicatorWidth = itemRect.width * (lengthPct / 100);
          const x = itemRect.left - containerRect.left + (itemRect.width - indicatorWidth) / 2;
          const y = itemRect.bottom - containerRect.top + 6;
          indicator.style.opacity = '1';
          indicator.style.width = `${indicatorWidth}px`;
          indicator.style.transform = `translate(${x}px, ${y}px)`;
        });
      });

      container.addEventListener('mouseleave', () => {
        indicator.style.opacity = '0';
      });
    }
  }
  customElements.define('gsa-brand-indicator', GsaBrandIndicator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsa-hero"] && !Shopify.designMode) return;
  try {
    
  class GsaScrollVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.scrubVh = parseFloat(this.dataset.scrubVh) || 200;
      this.ticking = false;
      this.primed = false;

      this.video.pause();
      this.video.currentTime = 0;

      this.onScroll = this.onScroll.bind(this);
      this.primeFrame = this.primeFrame.bind(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.video.addEventListener('loadedmetadata', this.primeFrame);
      if (this.video.readyState >= 1) {
        this.primeFrame();
      }
    }

    primeFrame() {
      // A currentTime set purely via script (never played) can leave the
      // browser showing a soft/undecoded frame until a real seek or
      // playback frame renders — which is why the very first paint looks
      // blurry until the user scrolls. Briefly playing forces one genuine
      // decoded frame through the normal video pipeline before we hand off
      // to scroll-driven scrubbing.
      if (this.primed) return;
      this.primed = true;
      const onPlaying = () => {
        this.video.pause();
        this.video.removeEventListener('playing', onPlaying);
        this.onScroll();
      };
      this.video.addEventListener('playing', onPlaying);
      this.video.play().catch(() => {
        this.video.removeEventListener('playing', onPlaying);
        this.onScroll();
      });
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        if (this.video.readyState >= 1 && this.video.duration) {
          const scrubDistance = (this.scrubVh / 100) * window.innerHeight;
          const progress = Math.min(Math.max(window.scrollY / scrubDistance, 0), 1);
          const target = progress * this.video.duration;
          if (Math.abs(this.video.currentTime - target) > 0.03) {
            this.video.currentTime = target;
          }
        }
        this.ticking = false;
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }
  }
  customElements.define('gsa-scroll-video', GsaScrollVideo);

  class GsaStaticVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.video.pause();
      this.video.currentTime = 0;
      this.primed = false;

      this.primeFrame = this.primeFrame.bind(this);
      this.video.addEventListener('loadedmetadata', this.primeFrame);
      if (this.video.readyState >= 1) {
        this.primeFrame();
      }
    }

    primeFrame() {
      // Same decode trick as GsaScrollVideo: a currentTime set purely via
      // script (never played) can leave the browser showing a soft/undecoded
      // frame, so we briefly play then immediately pause to force one real
      // decoded frame through, then hold on it.
      if (this.primed) return;
      this.primed = true;
      const onPlaying = () => {
        this.video.pause();
        this.video.removeEventListener('playing', onPlaying);
      };
      this.video.addEventListener('playing', onPlaying);
      this.video.play().catch(() => {
        this.video.removeEventListener('playing', onPlaying);
      });
    }
  }
  customElements.define('gsa-static-video', GsaStaticVideo);

  class GsaMultiVideo extends HTMLElement {
    connectedCallback() {
      this.clips = Array.from(this.querySelectorAll('.gsa-hero__video-clip'));
      if (!this.clips.length) return;

      this.index = 0;
      this.onEnded = this.advance.bind(this);

      this.clips.forEach((clip, i) => {
        const video = clip.querySelector('video');
        if (video) video.pause();
        clip.classList.toggle('is-active', i === 0);
      });

      this.playCurrent();
    }

    playCurrent() {
      const clip = this.clips[this.index];
      const video = clip ? clip.querySelector('video') : null;
      if (!video) {
        this.advance();
        return;
      }
      video.currentTime = 0;
      video.addEventListener('ended', this.onEnded, { once: true });
      video.play().catch(() => this.advance());
    }

    advance() {
      if (this.clips.length < 2) {
        this.playCurrent();
        return;
      }
      this.clips[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.clips.length;
      this.clips[this.index].classList.add('is-active');
      this.playCurrent();
    }

    disconnectedCallback() {
      const clip = this.clips && this.clips[this.index];
      const video = clip ? clip.querySelector('video') : null;
      if (video) video.removeEventListener('ended', this.onEnded);
    }
  }
  customElements.define('gsa-multi-video', GsaMultiVideo);

  function gsaInitBikeFinderForm() {
    const form = document.getElementById('GsaBikeFinderForm');
    if (!form || form.dataset.gsaReady) return;
    form.dataset.gsaReady = 'true';

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const modelUrl = form.querySelector('#GsaBikeModel').value;
      if (!modelUrl) return;

      window.location.href = modelUrl;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gsaInitBikeFinderForm);
  } else {
    gsaInitBikeFinderForm();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsa-shop-by-bike"] && !Shopify.designMode) return;
  try {
    
  class GsaBikeCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.gsa-bike-track');
      this.prevButton = this.querySelector('.gsa-bike-carousel__arrow--prev');
      this.nextButton = this.querySelector('.gsa-bike-carousel__arrow--next');
      if (!this.track || !this.prevButton || !this.nextButton) return;

      this.offset = 0;

      this.prevButton.addEventListener('click', () => this.step(-1));
      this.nextButton.addEventListener('click', () => this.step(1));
    }

    step(direction) {
      const cards = this.track.querySelectorAll('.gsa-bike-card');
      if (cards.length < 2) return;

      const stepDistance = cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
      if (!stepDistance) return;

      this.offset -= direction * stepDistance;
      this.track.style.setProperty('--gsa-marquee-offset', `${this.offset}px`);
    }
  }
  customElements.define('gsa-bike-carousel', GsaBikeCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsa-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  function gsaInitWelcomePopup() {
    const modal = document.getElementById('GsaWelcomePopupModal');
    if (!modal || modal.dataset.gsaReady) return;
    modal.dataset.gsaReady = 'true';

    const storageKey = 'gsaWelcomePopupSeen';
    let seen = true;
    try {
      seen = localStorage.getItem(storageKey) === 'true';
    } catch (e) {
      seen = true;
    }
    if (seen) return;

    const markSeen = () => {
      try {
        localStorage.setItem(storageKey, 'true');
      } catch (e) {
        // ignore storage errors (e.g. private browsing)
      }
    };

    const observer = new MutationObserver(() => {
      if (!modal.hasAttribute('open')) {
        markSeen();
        observer.disconnect();
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });

    const dismissButton = document.getElementById('GsaWelcomePopupDismiss');
    if (dismissButton) {
      dismissButton.addEventListener('click', () => modal.hide());
    }

    modal.show(null);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gsaInitWelcomePopup);
  } else {
    gsaInitWelcomePopup();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function gsaInitNavIndicator() {
    document.querySelectorAll('.header__inline-menu').forEach((nav) => {
      if (nav.dataset.gsaIndicatorReady) return;
      nav.dataset.gsaIndicatorReady = 'true';

      const list = nav.querySelector(':scope > ul');
      if (!list) return;

      const wrapper = nav.closest('.header-wrapper');
      const thickness = parseFloat(wrapper && wrapper.dataset.gsaIndicatorThickness) || 4;
      const lengthPct = parseFloat(wrapper && wrapper.dataset.gsaIndicatorLength) || 50;

      const indicator = document.createElement('div');
      indicator.className = 'gsa-nav-indicator';
      indicator.style.height = `${thickness}px`;
      indicator.innerHTML = '<span></span><span></span><span></span>';
      nav.appendChild(indicator);

      const items = list.querySelectorAll(
        ':scope > li > a.header__menu-item, :scope > li > header-menu > details > summary.header__menu-item'
      );
      items.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          const navRect = nav.getBoundingClientRect();
          const itemRect = item.getBoundingClientRect();
          const indicatorWidth = itemRect.width * (lengthPct / 100);
          const offset = itemRect.left - navRect.left + (itemRect.width - indicatorWidth) / 2;
          indicator.style.opacity = '1';
          indicator.style.width = `${indicatorWidth}px`;
          indicator.style.transform = `translateX(${offset}px)`;
        });
      });

      nav.addEventListener('mouseleave', () => {
        indicator.style.opacity = '0';
      });
    });
  }

  function gsaRunHeaderEnhancements() {
    try {
      gsaInitNavIndicator();
    } catch (error) {
      console.error('[GSA] nav indicator failed to initialise', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gsaRunHeaderEnhancements);
  } else {
    gsaRunHeaderEnhancements();
  }

  } catch(e) { console.error(e); }
})();
})();
